import React from 'react';
import { Link } from 'react-router-dom';




import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";

function Terms() {
  return (
    <Helmet title="Terms and Conditions">
      <CommonSection title="Terms & Conditions" />
      <div className=''>
        <h1 className='text-4xl font-semibold'>Terms of Service</h1>
        
        <h2 className='text-3xl mt-8 font'>1. Introduction</h2>
        <p>Welcome to Aspect Car Rental Services - your trusted partner in car rental services based in Nairobi, Kenya. By using our website and services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.</p>

        <h2 className='text-3xl mt-8'>2. Rental Agreement</h2>
        <p>When you rent a vehicle from us, you enter into a rental agreement. This agreement outlines the terms of the rental, including the rental duration, fees, and responsibilities. Make sure to review and understand the rental agreement before proceeding with the reservation.</p>

        <h2 className='text-3xl mt-8'>3. Reservation and Cancellation</h2>
        <p>To reserve a vehicle, you must provide accurate information and adhere to our reservation policies. Cancellations are subject to our cancellation policy, and fees may apply. Refer to the specific terms outlined during the reservation process.</p>

        <h2 className='text-3xl mt-8'>4. Vehicle Pickup and Return</h2>
        <p>When picking up a vehicle, ensure you have a valid driver's license, payment method, and any required documentation. Return the vehicle on time and in the same condition to avoid additional charges. Late returns may incur fees.</p>

        <h2 className='text-3xl mt-8'>5. Usage and Restrictions</h2>
        <p>Only authorized drivers are allowed to operate the rented vehicle. Use the vehicle responsibly and comply with traffic laws. Certain activities, such as off-road driving, may be restricted. Violating usage restrictions may result in penalties.</p>

        <h2 className='text-3xl mt-8'>6. Insurance and Liability</h2>
        <p>Our rental vehicles come with basic insurance coverage. Additional coverage options are available. Review the insurance terms and liability limitations. You are responsible for any damages or losses not covered by insurance during the rental period.</p>

        <h2 className='text-3xl mt-8'>7. Privacy Policy</h2>
        <p>
          We respect your privacy. Our privacy policy outlines how we collect, use, and protect your personal information. By using our services, you consent to the terms of our 
          <Link to="/privacy" className="text-blue-500 no-underline ml-1">
            <strong>privacy policy</strong> <i className="ri-arrow-right-up-line"></i></Link>.
        </p>

        <h2 className='text-3xl mt-8'>8. Governing Law</h2>
        <p>These terms and conditions are governed by and construed in accordance with the laws of Kenya. Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts in Nairobi, Kenya.</p>

        <p className="mt-8">By accepting these terms, you acknowledge that you have read, understood, and agreed to abide by the terms and conditions outlined above. If you have any questions, please contact our customer support.</p>
      </div>
    </Helmet>
  );
}

export default Terms;
